import SphSelect from './Select.vue';

export { SphSelect };
export default SphSelect;
